import { snackbar } from "@/core/controller/snackbar_controller"
import userService from "@/api/rest-administrative/user.service"
import { FALVORITE_REGIONAL_IDS } from "@/utils/regionalIds";

const state = {
  userConfigs: null,
  userConfigsLoadingButton: false
}

const mutations = {
  setUserConfigs(state, data) {
    state.userConfigs = data ? data : {}
  },
  setUserConfigsLoadingButton(state, data) {
    state.userConfigsLoadingButton = data
  }
}

const actions = {
  async fetchUserConfigs({ commit }) {
    try {
      const response = await userService.fetchUserConfigs()
      if (response.data == "") {
        const defaultData = {
          favoriteAgencyIds: [
            "BSCGVA",
            "BSCCTC",
            "BSCMGA",
            "BSCCEL",
            "BSCLNA"
          ],
          favoriteAgencyNotifications: false,
          favoriteCityIds: [
            4109401,
            4106902,
            4115200,
            4104808,
            4113700
          ],
          favoriteCityNotifications: false,
          favoriteRegionalIds: FALVORITE_REGIONAL_IDS,
          favoriteRegionalNotifications: true
        }
        commit('setUserConfigs', defaultData)
        return
      }
      commit('setUserConfigs', response.data)
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Erro",
        message: error.response.data.message,
        timeout: 3000,
      });
    }
  },
  async changeUserConfigs({ commit }, data) {
    commit('setUserConfigsLoadingButton', true)
    try {
      await userService.changeUserConfigs(data)
      snackbar.show({
        type: "success",
        title: "Sucesso",
        message: "Dados alterados com sucesso!",
        timeout: 3000,
      });
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Erro",
        message: error.response.data.message,
        timeout: 3000,
      });
    }
    finally {
      commit('setUserConfigsLoadingButton', false)
    }
  }
}

const getters = {
  userConfigs: (state) => state.userConfigs,
  userConfigsLoadingButton: (state) => state.userConfigsLoadingButton,
};

export default {
  state,
  mutations,
  actions,
  getters
}
